import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { AuditLog } from "@lib/types/Monitoring";

export const apiGetAuditLog = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/manager-audit-log` });
  return API.get<AuditLog>(url);
};

export const apiGetAuditLogs = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/manager-audit-log` });
  return API.get<PaginationType<AuditLog>>(url);
};
